/* FREUDEBOX central delivery estimate; Europe/Berlin, no external API. */
(() => {
'use strict';
if (customElements.get('freudebox-delivery')) return;
  function createFreudeboxCalendar() {
    const DAY = 86400000;
    const weekdays = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
    const months = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
    const berlin = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    const holidayCache = new Map();

    function date(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
    function add(d, n) { return new Date(d.getTime() + n * DAY); }
    function iso(d) { return d.toISOString().slice(0, 10); }
    function integer(value, fallback, min, max) {
      if (value === null || value === undefined || value === '') return fallback;
      const n = Number(value);
      return Number.isFinite(n) ? Math.max(min, Math.min(max, Math.trunc(n))) : fallback;
    }
    function dateSet(value) {
      const set = new Set();
      String(value || '').split(/[\s,;]+/).forEach(token => {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(token)) return;
        const parsed = new Date(token + 'T00:00:00Z');
        if (Number.isFinite(parsed.getTime()) && iso(parsed) === token) set.add(token);
      });
      return set;
    }
    function config(raw = {}) {
      const minDays = integer(raw.minDays, 1, 1, 10);
      return { ...raw,
        cutoffHour: integer(raw.cutoffHour, 12, 0, 23),
        cutoffMinute: integer(raw.cutoffMinute, 0, 0, 59),
        minDays,
        maxDays: Math.max(minDays, integer(raw.maxDays, 3, 1, 10)),
        bremenHolidays: raw.bremenHolidays !== false,
        packClosed: dateSet(raw.packClosedDates),
        deliveryClosed: dateSet(raw.deliveryClosedDates)
      };
    }
    function localParts(now) {
      const p = {};
      berlin.formatToParts(now).forEach(part => { if (part.type !== 'literal') p[part.type] = Number(part.value); });
      return { day: date(p.year, p.month, p.day), minutes: p.hour * 60 + p.minute };
    }
    // Gregorian Easter (Meeus/Jones/Butcher); dates are calendar days, not local timestamps.
    function easter(year) {
      const a = year % 19, b = Math.floor(year / 100), c = year % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      const n = h + l - 7 * m + 114;
      return date(year, Math.floor(n / 31), n % 31 + 1);
    }
    function holidays(year, bremen) {
      const key = year + ':' + Boolean(bremen);
      if (holidayCache.has(key)) return holidayCache.get(key);
      const e = easter(year);
      const days = [date(year, 1, 1), add(e, -2), add(e, 1), date(year, 5, 1), add(e, 39), add(e, 50), date(year, 10, 3), date(year, 12, 25), date(year, 12, 26)];
      if (bremen) days.push(date(year, 10, 31));
      const set = new Set(days.map(iso)); holidayCache.set(key, set); return set;
    }
    function packDay(d, c) {
      const w = d.getUTCDay();
      return w >= 1 && w <= 5 && !holidays(d.getUTCFullYear(), c.bremenHolidays).has(iso(d)) && !c.packClosed.has(iso(d));
    }
    function deliveryDay(d, c) {
      return d.getUTCDay() !== 0 && !holidays(d.getUTCFullYear(), false).has(iso(d)) && !c.deliveryClosed.has(iso(d));
    }
    function nextPackDay(d, c) {
      for (let n = 0; n < 400; n++, d = add(d, 1)) if (packDay(d, c)) return d;
      throw new Error('Kein Verpackungstag im Berechnungszeitraum.');
    }
    function deliveryAfter(dispatch, n, c) {
      let cursor = dispatch, counted = 0;
      for (let tries = 0; tries < 400; tries++) {
        cursor = add(cursor, 1);
        if (deliveryDay(cursor, c) && ++counted === n) return cursor;
      }
      throw new Error('Kein Zustelltag im Berechnungszeitraum.');
    }
    const fullMonths = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    function rangeText(start, end, longMonth = false, tight = false) {
      const y1 = start.getUTCFullYear(), y2 = end.getUTCFullYear(), m1 = start.getUTCMonth(), m2 = end.getUTCMonth();
      const short = d => weekdays[d.getUTCDay()] + ', ' + d.getUTCDate() + '.';
      const names = longMonth ? fullMonths : months;
      const full = d => short(d) + ' ' + names[d.getUTCMonth()];
      const endText = d => tight ? d.getUTCDate() + '. ' + names[d.getUTCMonth()] : full(d);
      if (iso(start) === iso(end)) return full(start);
      if (y1 !== y2) return full(start) + ' ' + y1 + ' – ' + endText(end) + ' ' + y2;
      if (m1 !== m2) return full(start) + ' – ' + endText(end);
      return short(start) + ' – ' + endText(end);
    }
    function presentation(start, end) {
      const dayNames = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
      const sameDay = iso(start) === iso(end);
      const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
      const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth();
      const monthLabel = sameMonth ? fullMonths[start.getUTCMonth()] : months[start.getUTCMonth()] + '/' + months[end.getUTCMonth()];
      return {
        monthLabel,
        daysLabel: String(start.getUTCDate()) + (sameDay ? '' : '–' + end.getUTCDate()),
        weekdayLabel: dayNames[start.getUTCDay()] + (sameDay ? '' : ' bis ' + dayNames[end.getUTCDay()]),
        precise: sameMonth ? '' : rangeText(start, end, true),
        accessibleRange: rangeText(start, end, true)
      };
    }
    function compactRange(start, end, abbreviated = false) {
      const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
      const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth();
      const full = d => d.getUTCDate() + '. ' + (abbreviated ? months : fullMonths)[d.getUTCMonth()];
      if (iso(start) === iso(end)) return full(start);
      if (!sameYear) return full(start) + ' ' + start.getUTCFullYear() + ' – ' + full(end) + ' ' + end.getUTCFullYear();
      if (!sameMonth) return full(start) + ' – ' + full(end);
      return start.getUTCDate() + '.–' + weekdays[end.getUTCDay()] + ' ' + full(end);
    }
    function calculate(now, raw = {}) {
      if (!(now instanceof Date) || !Number.isFinite(now.getTime())) throw new Error('Ungültiger Zeitpunkt.');
      const c = config(raw), local = localParts(now), today = local.day;
      const beforeCutoff = local.minutes < c.cutoffHour * 60 + c.cutoffMinute;
      const candidate = beforeCutoff && packDay(today, c) ? today : add(today, 1);
      const dispatch = nextPackDay(candidate, c);
      const start = deliveryAfter(dispatch, c.minDays, c), end = deliveryAfter(dispatch, c.maxDays, c);
      const distance = Math.round((start.getTime() - today.getTime()) / DAY);
      const relative = distance === 1 ? 'morgen' : distance === 2 ? 'übermorgen' : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'][start.getUTCDay()];
      return { today: iso(today), dispatch: iso(dispatch), start: iso(start), end: iso(end), relative, distance, presentation: presentation(start, end), compactRange: compactRange(start, end), compactShort: compactRange(start, end, true), range: rangeText(start, end), rangeLong: rangeText(start, end, true), rangeTight: rangeText(start, end, false, true), rangeLongTight: rangeText(start, end, true, true) };
    }
    return { calculate, rangeText, dateSet, presentation, compactRange };
  }

const calendar = createFreudeboxCalendar();
class FreudeboxDelivery extends HTMLElement {
  connectedCallback() {
    if (this._active) return;
    // Defer initialization until the parser has supplied the JSON children.
    this._initTimer = setTimeout(() => this.init(), 0);
  }
  init() {
    if (!this.isConnected || this._active) return;
    const node = this.querySelector('[data-fbd-config]');
    if (!node) return;
    try { this._config = JSON.parse(node.textContent); } catch (_) { return; }
    this._active = true;
    this._relative = this.querySelector('.fbd-relative');
    this._range = this.querySelector('.fbd-range');
    this._range.innerHTML = '<span class="fbd-range-desktop"></span><span class="fbd-range-mobile" aria-hidden="true"></span>';
    this._desktop = this._range.firstElementChild;
    this._mobile = this._range.lastElementChild;
    this._form = this.closest('form');
    this._form?.setAttribute('data-fbd-central', '');
    this.syncCounter();
    if (this._form) {
      this._observer = new MutationObserver(() => this.syncCounter());
      this._observer.observe(this._form, {childList:true, subtree:true, characterData:true});
    }
    this._onVisibility = () => { if (!document.hidden) this.update(); };
    document.addEventListener('visibilitychange', this._onVisibility);
    this.update();this.tick();
  }
  syncCounter() {
    this._form?.querySelectorAll('.label-counter').forEach(node => {
      // Ignore the old widget's script/link/empty marker when testing emptiness.
      const clone = node.cloneNode(true);
      clone.querySelectorAll('script,style,link').forEach(el => el.remove());
      const empty = !clone.textContent.trim() && !clone.querySelector('img,svg,iframe,canvas');
      node.toggleAttribute('data-fbd-empty-counter', empty);
    });
  }
  update() {
    try {
      const estimate = calendar.calculate(new Date(), this._config);
      const key = estimate.relative + '|' + estimate.compactRange;
      if (key === this._lastEstimate) return;
      this._lastEstimate = key;
      this._relative.hidden = false;
      this._relative.textContent = estimate.relative + ', ';
      this._desktop.textContent = estimate.compactRange;
      this._mobile.textContent = estimate.compactShort;
      this.querySelector('.fbd-date').setAttribute('aria-label', estimate.relative + ', ' + estimate.rangeLong);
    } catch (_) {
      this._relative.hidden = true;
      this._desktop.textContent = this._mobile.textContent = 'Lieferung in 1–3 Werktagen nach Versand';
    }
  }
  tick() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => { if (this.isConnected) { this.update();this.tick(); } }, 60000 - Date.now() % 60000 + 30);
  }
  disconnectedCallback() {
    clearTimeout(this._initTimer);clearTimeout(this._timer);
    this._observer?.disconnect();
    document.removeEventListener('visibilitychange', this._onVisibility);
    this._active = false;
  }
}
customElements.define('freudebox-delivery', FreudeboxDelivery);
})();
